import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    save: {},
    table: createTableState(),
    filterData: undefined
})

// getters
const getters = {}

// actions
const actions = {
    // get records
    async get({state, commit}, {page, filterData, product_id} = {}) {
        commit('setLoading', true)

        state.filterData = filterData;

        let params = {};
        if (page) {
            if (page.current) params.page = page.current;
            if (page.pageSize) params.page_limit = page.pageSize;
        }
        if (state.filterData) {
            params = {...params, ...state.filterData};
        }

        const res = await this._vm.axios.get(this._vm.endpoints['ecommerce_product_price'], {
            params: params,
            urlVars: {productId: product_id}
        })

        const {data, meta} = res.data
        commit('updateTableData', data)
        commit('updatePagination', normalizePagination(meta))

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    async add({commit}, {formData, product_id}) {
        commit('setLoading', true)

        try {
            const res = await this._vm.axios.post(this._vm.endpoints['ecommerce_product_price'], formData, {
                urlVars: {productId: product_id}
            })

            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    async update({commit}, {id, formData, product_id}) {
        commit('setLoading', true)

        try {
            const res = await this._vm.axios.put(this._vm.endpoints['ecommerce_product_price'] + '/' + id, formData, {
                urlVars: {productId: product_id}
            })

            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    //  delete record
    async delete({commit, dispatch}, {id, product_id}) {
        let successDeleted = [];
        if (id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
        } else {
            for (let i = 0; i < id.length; i++) {
                const {data} = await this._vm.axios.delete(this._vm.endpoints['ecommerce_product_price'] + '/' + id[i], {
                    urlVars: {productId: product_id}
                });
                if (data.status) {
                    this._vm.$message.success(this._vm.$t('messages.deleteOk'));
                    successDeleted.push(id[i]);
                } else {
                    this._vm.$message.error(data.message)
                }
            }

            return successDeleted;
        }
    },
}

// mutations
const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updateTableData(state, data) {
        state.table.data = data
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateSaveData(state, data) {
        state.save.data = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}